import { Injectable } from '@angular/core';
import { UndoRedoHelper } from '@shared/undo/undo-redo.helper';
import { SelectionModelService } from '../components/article/service/selection-model.service';
import { CopyPasteAdditionalOperations } from '../components/article/manager/copy-paste-additional-operations';
import { ArticleLoadingManager } from '@article/service/article-loading.manager';
import { ClearService } from './clear.service';
import { ReplaceLabelingArticleHelper } from '../components/label/replace-labeling-helper/replace-labeling-article.helper';

@Injectable({providedIn: 'root'})
export class ClearServiceInitializer {

  constructor(private clearService: ClearService,
              private undoRedoHelper: UndoRedoHelper,
              private selectionModelService: SelectionModelService,
              private copyPasteAdditionalOperations: CopyPasteAdditionalOperations,
              private articleLoadingManager: ArticleLoadingManager,
              private replaceLabelingArticleHelper: ReplaceLabelingArticleHelper,
  ) {
  }

  public initialize() {
    this.clearService.initialize(
      this.undoRedoHelper,
      this.selectionModelService,
      this.copyPasteAdditionalOperations,
      this.articleLoadingManager,
      this.replaceLabelingArticleHelper,
    );
  }
}
